/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  hasMany,
  type AsyncBelongsTo,
  type AsyncHasMany,
} from '@warp-drive/legacy/model';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type ProgressionType from '@linc-technologies/linced-common/enums/progression-type';
import { resolved } from '@linc-technologies/linced-common/utils/arrays';
import type Expectation from 'linced-admin/models/milestones/expectation';
import type Level from 'linced-admin/models/milestones/level';
import type Milestone from 'linced-admin/models/milestones/milestone';
import type MilestoneSet from 'linced-admin/models/milestones/milestone-set';
import type UsageSet from 'linced-admin/models/schools/usage-set';

// Proto: milestones.TemplateSet.
export default class Set extends Model {
  declare [Type]: 'milestones/set';

  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('string', { defaultValue: '' })
  declare label: string;

  @attr('string', { defaultValue: '' })
  declare description: string;

  @attr('number', { defaultValue: 0 })
  declare progressionType: EnumValue<typeof ProgressionType> | 0;

  @attr('boolean', { defaultValue: false })
  declare isPublished: boolean;

  @belongsTo('milestones/milestone-set', { async: true, inverse: null })
  declare milestoneSetTemplateId: AsyncBelongsTo<MilestoneSet>;

  @alias('milestoneSetTemplateId')
  declare milestoneSetTemplate: AsyncBelongsTo<MilestoneSet>;

  @alias('milestoneSetTemplate.id')
  declare milestone_set_template_id: string | null | undefined;

  @hasMany('milestones/milestone', { async: true, inverse: 'templateSetId' })
  declare milestones: AsyncHasMany<Milestone>;

  @hasMany('milestones/level', { async: true, inverse: 'templateSetId' })
  declare levels: AsyncHasMany<Level>;

  @hasMany('milestones/expectation', { async: true, inverse: 'templateSetId' })
  declare expectations: AsyncHasMany<Expectation>;

  // Usage sets membership
  @hasMany('schools/usage-set', { async: true, inverse: 'milestoneSetIds' })
  declare usageSetIds: AsyncHasMany<UsageSet>;

  @computed('usageSetIds.content.[]')
  get usageSetsArray() {
    return resolved(this.usageSetIds);
  }
}
